import TnC from "../pages/terms-and-conditions/tnc";
import PrivacyPolicy from "../pages/privacy-policy/privacy";
import CookiePolicy from "../pages/cookie-policy/cookie";

export const PUBLIC_ROUTES = {
  TERMS_AND_CONDITIONS: {
    path: "/terms-and-conditions",
    component: TnC,
    title: "Terms and Conditions",
  },
  PRIVACY_POLICY: {
    path: "/privacy-policy",
    component: PrivacyPolicy,
    title: "Terms and Conditions",
  },
  COOKIE_POLICY: {
    path: "/cookie-policy",
    component: CookiePolicy,
    title: "Cookie Policy",
  },
};
